import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router  } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import { DentalService } from '../../_service/dental.service';
import { LabService } from 'src/app/_service/lab.service';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
@Component({
  selector: 'app-lab-payment-modal',
  templateUrl: './lab-payment-modal.component.html',
  styleUrls: ['./lab-payment-modal.component.css']
})
export class LabPaymentModalComponent implements OnInit {

  lead_id;payment_type;scan_id;
  PaymentLinkForm: FormGroup;
  copypaymentlink:any;
  show_copy:boolean=false;
  loading:boolean = false;
  constructor(public dialogRef: MatDialogRef<LabPaymentModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,private router:Router,private sharedapi:SharedService, private leadapi:LeadsService,private formBuilder: FormBuilder,private dentalapi:DentalService,private labapi: LabService) { 
     
    this.lead_id = data.lead_id;
    this.scan_id = data.scan_id;
    this.payment_type = data.type;
    this.PaymentLinkForm = this.formBuilder.group({
      'patient_name' : [null, Validators.required],
      'mobile' : [null, Validators.required],
      'amount' : [null, Validators.required],
      'description' : [null, Validators.required],
      'leadid' : [null],
      'payment_type' : this.payment_type,
      'lab_lead_id' :[null,Validators.required]
    })
    
  }

  copyToClipboard(element) {
    element.select();
    document.execCommand('copy');
    this.sharedapi.presentToast('Link copied to clipboard.');
  }

  ngOnInit(): void {
    this.getLabLeadDetails();
  }

  closeDialog() {
    this.dialogRef.close({ event: 'close', data: '' });
  }
  getLabLeadDetails(){
    this.labapi.getLabLeadRecord(this.lead_id).subscribe((data:any) =>{
      //console.log(data.data.balance);
      if(data.status)
      {
        let patientID = data.data.glamyo_patient_id;
        let patient = data.data.lead_name;
        let bdName = data.data.bdName;
        let details = 'PatientID: '+patientID+', PatientName: '+patient+', BdName: '+bdName;
        this.PaymentLinkForm.controls['patient_name'].setValue(data.data.lead_name);
        this.PaymentLinkForm.controls['mobile'].setValue(data.data.mobile);
        this.PaymentLinkForm.controls['description'].setValue(details);
        this.PaymentLinkForm.controls['lab_lead_id'].setValue(this.lead_id);
        //console.log(this.PaymentLinkForm.value);
        
      }
      else{
        if(data.error_type!='no')
        this.sharedapi.presentToast('Error Occured');
      }
    },
    error => {
        this.sharedapi.checkError(error);
    });
  }

  sendPaymentLink(){
    this.loading = true;
    if (this.PaymentLinkForm.invalid) {
      this.loading = false;
      return;
    }
    let formData = this.PaymentLinkForm.value
    
    this.leadapi.share_payment_link(formData).subscribe((data:any) =>{
      this.loading = false;
      if (data.data.hasOwnProperty("error")) {
        this.sharedapi.presentToast(data.data.error.description);
      }else{
        this.sharedapi.presentToast("Payment Link Sent Successfully!");
        this.show_copy = true;
        
        this.copypaymentlink = data.data.short_url;
      }
    },
    error => {
        this.sharedapi.checkError(error);
    });
  }
  


}